/**
 * DialogProvider owns the state and renders AppDialog using this configuration.
 * Part dialog hooks supply async load/save callbacks to startDialog. Open requests
 * are ignored while a dialog is already open.
 */

import PartAddDialog, { renderTitle } from 'vms/features/parts/PartAddDialog';
import PartEditDialog from 'vms/features/parts/PartEditDialog';

import type { DialogConfig } from './types';

const DIALOGS_CONFIG: DialogConfig = {
  PART_ADD_DIALOG: {
    component: PartAddDialog,
    title: renderTitle,
    icon: 'barcode',
  },
  PART_EDIT_DIALOG: {
    component: PartEditDialog,
    title: 'Edit Part',
    icon: 'barcode',
  },
};

export default DIALOGS_CONFIG;
